import { render, staticRenderFns } from "./TopupHistoryTable.vue?vue&type=template&id=05942c1c&scoped=true&"
import script from "./TopupHistoryTable.vue?vue&type=script&lang=js&"
export * from "./TopupHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./TopupHistoryTable.vue?vue&type=style&index=0&id=05942c1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05942c1c",
  null
  
)

export default component.exports